import { createAction } from "@reduxjs/toolkit";

export const isAddApplicationDialogOpenAction = createAction('isAddApplicationDialogOpen', function prepare(isOpen: boolean) {
    return {
        payload: {
            isOpen
        },
    }
});
